export enum TicketType {
    MC4_PUNCH_CARD = 'MC4_PUNCH_CARD',
    TRX_PUNCH_CARD = 'TRX_PUNCH_CARD',
    TRX_QR_TICKET = 'TRX_QR_TICKET',
}

type TicketBase = {
    ticketId: string;
    ticketType: TicketType;
    ticketDisplay: string;
};

export type Mc4PunchCardTicket = {
    ticketType: TicketType.MC4_PUNCH_CARD;
    ticketBase64: string;
} & TicketBase;

export type TrxPunchCardTicket = {
    ticketType: TicketType.TRX_PUNCH_CARD;
    ticketBase64: string;
} & TicketBase;

export type TrxQrTicket = {
    ticketType: TicketType.TRX_QR_TICKET;
    ticketBase64: string;
} & TicketBase;

export type Ticket = Mc4PunchCardTicket | TrxPunchCardTicket | TrxQrTicket;

export enum TicketReceiptType {
    PUNCH_CARD = 'PUNCH_CARD',
    QR_TICKET = 'QR_TICKET',
}

type TicketReceiptBase = {
    receiptType: TicketReceiptType;
};

export type PunchCardTicketReceipt = {
    receiptType: TicketReceiptType.PUNCH_CARD;
    ticketBase64: string;
} & TicketReceiptBase;

export type QrTicketReceipt = {
    receiptType: TicketReceiptType.QR_TICKET;
    ticketId: string;
} & TicketReceiptBase;

export type TicketReceipt = PunchCardTicketReceipt | QrTicketReceipt;

export enum EntryPlusState {
    CREATED = 'CREATED',
    SCANNED = 'SCANNED',
    ALIAS_PENDING = 'ALIAS_PENDING',
    APPROVED = 'APPROVED',
    BOOKED = 'BOOKED',
}

export interface TicketAndState {
    ticket: Ticket;
    state: EntryPlusState;
    createdAt: string;
}
